import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify();

export default DOMPurify.sanitize;
